import { render } from "./index.vue?vue&type=template&id=2847d5a3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2847d5a3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2847d5a3"

export default script